<button class="btn btn-lg btn-flat" (click)="delete()" *ngIf="!deleted">
  <em class="icon">delete</em>
</button>
<button class="btn btn-lg btn-flat" (click)="restore()" *ngIf="deleted">
  <em class="icon">settings_backup_restore</em>
</button>
